class GdprExplanationsController {
    /**
     * @param {Object} evaluationService
     * @param {$stateParams} $stateParams
     * @param {$timeout} $timeout
     * @param {$state} $state
     * @param {$mdDialog} $mdDialog
     * @param {$mdToast} $mdToast
     *
     */

    constructor(evaluationService, $state, $mdDialog, $mdToast) {
        this.evaluationService = evaluationService;
        this.state = $state;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;

        evaluationService
            .getSettingsSurvey()
            .then((data) => {
                this.basicSurvey = data;
                if (this.currentParameter) {
                    this.currentParameter = this.basicSurvey.find(
                        (x) =>
                            x.sectionTitle ===
                            this.currentParameter.sectionTitle
                    );
                }
            })
            .catch((err) => {
                console.log(err.stateText);
            });

        this.selectGdParameter = (parameter) => {
            this.currentParameter = parameter;
            this.currentParameter.descriptionsArray = Object.keys(
                this.currentParameter.descriptions
            ).map((key) => this.currentParameter.descriptions[key]);

            this.currentParameter.questionsArray = Object.keys(
                this.currentParameter.questions
            ).map((key) => this.currentParameter.questions[key]);
        };

        this.saveFlagDescription = (description) => {
            evaluationService.patchSettingsFlagExplanations(
                description.id,
                description.flagDescription
            );
        };

        this.saveAnswerDescription = (answers) => {
            evaluationService.patchSettingsAnswerExplanations(
                answers.id,
                answers.explanation
            );
        };
    }
}

GdprExplanationsController.$inject = [
    "EvaluationService",
    "$stateParams",
    "PedagogicalService",
    "UserService",
    "$mdDialog",
    "$mdToast",
];

export default GdprExplanationsController;



// WEBPACK FOOTER //
// ./src/app/pages/manageSkills/gdprExplanations/gdprExplanationsController.js